import React, { useState } from "react";
import "../../../../../styles/StayUptoDateCSS/SubComponents.css";
import { useLocation, useParams } from "react-router-dom";
import track, {
  TRACKING_TYPES,
} from "../../../../../Utils/SupabaseServices/Track";
import { updateRefClick } from "../../../../../Utils/SupabaseServices/ContentDatabase";
// import { useLoadTrendingProducts } from "../../../../../Utils/customHooks/UpToDateContent/useLoadTrendingProducts";
import ImagePostCarouselTag from "../../../../../components/GeneralPostTag/ImagePostCarouselTag";
import ImagePostTag from "../../../../../components/GeneralPostTag/ImagePostTag";
import VideoPostTag from "../../../../../components/GeneralPostTag/VideoPostTag";
import DataSkeleton from "../../../../../components/StayUpToDateComponent/UpToDateComponents/DataSkeleton";
import { useDomLoaded } from "../../../../../hooks/DomLoadedContext";
import DashboardTemplate from "../StructureTemplates/DashboardTemplate";
import SeeMoreTile from "../StructureTemplates/SeeMoreTile";
import NoPostMsg from "../../../../../components/NoPostMsg/NoPostMsg";
import { useLoadTrendingProductsMaxCount } from "../../../../../Utils/customHooks/UpToDateContent/useLoadTrendingProductsMaxCount";

const TrendingProductsWrapper = (props: any) => {
  const { user_id, username, numberOfDays, isLinks, brand_color, component, from } =
    props;

  const {
    key,
    name: title,
    postIds,
    details,
    cta,
    query,
    removed_postids: removedPostIds,
    content_order,
    content_shape,
    content_sound,
    type,
    unique_id,
    route_name
  } = component;

  const [numberOfClicks, startDate, endDate, days] = details.split(",");
  const param = useParams();
  const location = useLocation();
  const domLoaded = useDomLoaded();
  const { isLoading: TrendingProductsLoading, data: TrendingProducts }: any =
    useLoadTrendingProductsMaxCount(
      user_id,
      username,
      title,
      numberOfClicks,
      removedPostIds,
      startDate,
      endDate,
      days,
      false,
      type
    );

  function handleRedirect(
    postId: string,
    media_url: string,
    platform: string,
    title: any,
    name: any,
    isLinks?: boolean
  ) {
    track("Post Click", TRACKING_TYPES.EVENT, {
      pathname: location.pathname,
      details: {
        post_id: postId,
        media_url: media_url,
        title: title,
        name: name,
        platform: platform,
        ...(param?.id ? { id: param?.id } : {}),
      },
      user_id: user_id,
      title: "Stay Up To Date",
    });
    if (isLinks === true) {
      track("Redirect to shop link", TRACKING_TYPES.EVENT, {
        pathname: location.pathname,
        details: {
          post_id: postId,
          media_url: media_url,
          platform: platform,
          name: name,
        },
        user_id: user_id,
        title: "Stay Up To Date",
      });
    } else if (isLinks === false) {
      track("Redirect to original post", TRACKING_TYPES.EVENT, {
        pathname: location.pathname,
        details: {
          post_id: postId,
          media_url: media_url,
          platform: platform,
          name: name,
        },
        user_id: user_id,
        title: "Stay Up To Date",
      });
    }

    updateRefClick(postId, user_id);
  }

  const noContentMessage = type === "trending content" ? "No Trending Content Yet" : "No Trending Products Yet";

  return (
    <>
      <div>
        {TrendingProductsLoading || !domLoaded ? (
          <div className="outer-container-subcomponents">
            <DataSkeleton dashboard={true} />{" "}
          </div>
        ) : (
          <div className="outer-container-subcomponents">
            {TrendingProducts && TrendingProducts?.data && TrendingProducts?.data?.length ? (
              <div className="links-grid-container-subcomponents">
                {TrendingProducts &&
                  TrendingProducts?.data?.slice(0, 25).map((link: any, index: any) => (
                    <DashboardTemplate
                      key={index}
                      link={link}
                      handleShop={handleRedirect}
                      title={title}
                      brand_color={brand_color}
                      content_shape={content_shape}
                      content_sound={content_sound}
                      type={type}
                    />
                  ))}
                <SeeMoreTile
                  data={TrendingProducts?.data}
                  total_count={TrendingProducts?.total_count}
                  type={type}
                  unique_id={route_name || unique_id}
                  user_id={user_id}
                  username={username}
                  component={component}
                />
              </div>
            ) : (
              <NoPostMsg message={noContentMessage} />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default TrendingProductsWrapper;


